export enum WorkFrom {
    Onsite = 1,
    Remote = 2
}
export interface IUserMast {
    login_ID?: number,
    user_Name?: string,
    login_Name?: string,
    user_EmailID?: string,
    branch_ID?: number,
    branchName?: string,
    user_Status?: boolean,
    temp_Inactive?: boolean,
    login_Password?: string,
    workFrom?: WorkFrom,
    user_added_By?: number,
    //for recruiter allocation purpose 
    role_ID?: number,
    role_Name?: string,
    req_ID?: number,
    is_allocated?: boolean,

    role?: number,
    date_Of_Joining?: Date | null,
    experience_In_Month?: number | null,
    iMap_Password?: string,
    exclude_From_Report?: boolean,
    is_Link_User?: boolean,
    extension_ID?: any,
    team_Lead?: number,
    resource_Manager?: number,
    head?: number,
    isResourceManager?: boolean,
    recruiter_Head?: boolean,
    sales_Head?: boolean,
    user_Employee_ID?: string,
}